import React from "react";
import { Input, Form, DatePicker } from "antd";
import { useForm } from "antd/es/form/Form";
import "../Dashboard/Dashboard.css";
import HolidaysService from "../../Services/HolidaysService";
import dayjs from "dayjs";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";
interface HolidayParams {
  onDismiss: (confirmed: boolean) => void;
  record: any;
}
const HolidayDetails = ({ onDismiss, record }: HolidayParams) => {

  const [form] = useForm();
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (record?.id !== undefined && record?.id !== "") {
      form.setFieldsValue({
        name: record?.name !== undefined ? record?.name : "",
        date: record?.date !== undefined ? dayjs(record?.date) : "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record?.id]);
  return (
    <>
      <SAModal
        title={
          record?.id !== undefined ? `Edit ${record?.name}` : "Add new Holiday"
        }
        width={340}
        isLoading={loading}
        open={true}
        okText={"Save"}
        cancelText={"Cancel"}
        onOk={() => {
          let Id =
            record?.id !== undefined && record?.id !== null ? record?.id : "";
          setLoading(true);
          form
            ?.validateFields()
            .then(async (values: any) => {
              HolidaysService.addUpdate(Id, { ...values, date: values?.date?.format("MM-DD-YYYY") }).then((res) => {
                if (res?.status) {
                  onDismiss(true);
                } else {
                  onDismiss(false);
                }
              });
            })
            .catch((err) => {
              setLoading(false);
            });
        }}
        onCancel={() => {
          onDismiss(false);
        }}
        okButtonProps={{ disabled: false }}
        cancelButtonProps={{ disabled: false }}
      >
        <Form form={form} >
          <Form.Item
            className="custom-form-item"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label="Name"
            name={["name"]}
            rules={[
              {
                required: true,
                message: "Name is required",
              },
            ]}
          >
            <Input placeholder="Name" className="line-height-28"
              onChange={(e) => {
                const value = e.target.value;
                const capitalized = value.charAt(0).toUpperCase() + value.slice(1);
                form.setFieldsValue({ name: capitalized });
              }}
            />
          </Form.Item>
          <Form.Item
            className="custom-form-item"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label="Date"
            name={["date"]}
            rules={[
              {
                required: true,
                message: "Date is required",
              },
            ]}
          >
            <DatePicker
              placeholder="Date"
              format='DD/MM/YYYY'
              style={{ width: "100%", height: 28 }}
            />
          </Form.Item>
        </Form>
      </SAModal>
    </>
  );
};
export default HolidayDetails;
